import React from "react";
import { useTheme } from "../../context/ThemeContext";
// import { getThemeClasses } from "./utils/themeClass"; // adjust path if needed

export default function BgMadness() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  return (
    <>
      {/* Full-page background */}
      <div
        className={`fixed inset-0 z-[-1] pointer-events-none transition-colors duration-500 ${
          isDark
            ? "bg-gradient-to-b from-[#1a1a3e] via-[#12122b] to-[#0d0d1a]"
            : "bg-gradient-to-b from-[#f0f9ff] via-[#e0f2fe] to-[#bae6fd]"
        }`}
      />

      {/* Glows */}
      <div
        className={`fixed top-[5%] left-[8%] w-80 h-80 rounded-full blur-[100px] z-[-1] animate-pulse-slow pointer-events-none transition-colors duration-500 ${
          isDark ? "bg-[#00F0FF] opacity-20" : "bg-sky-400 opacity-25"
        }`}
      />
      <div
        className={`fixed top-[30%] left-[60%] w-60 h-60 rounded-full blur-[90px] z-[-1] animate-flicker pointer-events-none transition-colors duration-500 ${
          isDark ? "bg-[#FF007F] opacity-15" : "bg-pink-400 opacity-20"
        }`}
      />
      <div
        className={`fixed top-[65%] left-[25%] w-56 h-56 rounded-full blur-[80px] z-[-1] animate-glow pointer-events-none transition-colors duration-500 ${
          isDark ? "bg-[#00FFA2] opacity-15" : "bg-emerald-300 opacity-20"
        }`}
      />
      <div
        className={`fixed top-[80%] left-[70%] w-64 h-64 rounded-full blur-[100px] z-[-1] animate-flicker pointer-events-none transition-colors duration-500 ${
          isDark ? "bg-[#FFD700] opacity-10" : "bg-yellow-300 opacity-15"
        }`}
      />
      <div
        className={`fixed top-[45%] left-[40%] w-72 h-72 rounded-full blur-[90px] z-[-1] animate-glow pointer-events-none transition-colors duration-500 ${
          isDark ? "bg-[#7F00FF] opacity-10" : "bg-violet-400 opacity-15"
        }`}
      />
      <div
        className={`fixed top-[90%] left-[10%] w-60 h-60 rounded-full blur-[80px] z-[-1] animate-pulse-slow pointer-events-none transition-colors duration-500 ${
          isDark ? "bg-[#FF4500] opacity-10" : "bg-orange-300 opacity-15"
        }`}
      />
    </>
  );
}
